import { QueryConfig } from "store/utils/query-config";

export const FBCallLogsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-startedAt"],
  },
};
